export const assessmentData = {
  introduction: "Please review each statement in each section and assess your company's performance. A Databox team member will review the results with you and offer recommendations to improve.",
  
  sections: [
    {
      id: 1,
      title: "Align",
      description: "Success can't be achieved unless it's defined. The first step in making performance predictable is to pick metrics and set goals that will measure the success of your initiatives.",
      questions: [
        "We have selected the right metrics to track our output/activities and measure our outcomes/impact.",
        "We set our business goals with confidence.",
        "Our business goals are challenging, but achievable, on a consistent basis.",
        "Our stakeholders (within each function and across our company) agree on what success looks like."
      ]
    },
    {
      id: 2,
      title: "Analyze",
      description: "Once everyone is aligned around what success looks like, the next step is to make data actionable by making performance insights accessible to everyone at all times.",
      questions: [
        "We make performance data accessible to everyone at all times, so that everyone is empowered to act.",
        "We have tools and processes in place to ensure everyone knows they are on-track or off-track vs. goal(s).",
        "We understand the correlation between our outputs and the outcomes they produce.",
        "We can easily drill down from high-level metrics to dimensional metrics and leading indicators in order to determine cause and effect."
      ]
    },
    {
      id: 3,
      title: "Adjust",
      description: "At this point, you've done all the work to know which metrics to track and which goals to set. You've built strong dashboards to give insight into this data. Now, you have to make sure you actually make use of it!",
      questions: [
        "We have a firm grasp of how we're performing on an ongoing basis.",
        "We know the actions we need to take based on what our data is showing us.",
        "We make small adjustments to our activities in real-time as progress and results are happening.",
        "We plan initiatives and prioritize execution based on performance."
      ]
    },
    {
      id: 4,
      title: "Adopt",
      description: "The Adopt stage is more so for senior members of your team and is focused on larger processes that can help encourage adoption of Predictable Performance across the entire organization.",
      questions: [
        "We have an annual planning process (for our business) that starts with reviewing our previous year's performance.",
        "We have an annual financial model that models our expected growth based on historical performance and upcoming initiatives.",
        "We debate what our objectives and initiatives should be for the upcoming year based on expected financial impact.",
        "We clearly communicate our annual plans to the company so that everyone is clear on our direction & focus.",
        "We have reporting mechanisms in place to track progress against these plans & hold ourselves accountable to targets."
      ]
    }
  ],
  
  interpretations: [
    {
      range: [80, 100],
      label: "Well-Established and On Track",
      description: "Your score indicates a strong grasp of your business performance, with solid infrastructure and tracking in place. You're already leveraging data effectively, with only a few areas left to refine. Book a call with us to explore whether our solutions align with your needs for continued growth."
    },
    {
      range: [60, 80],
      label: "Strong Progress with Room to Grow",
      description: "Your score shows that you're actively working to improve your business performance and data-driven decision-making. You've taken the time to assess where you stand, which signals a commitment to growth. With the right strategies, you can refine your approach, strengthen transparency, and drive even better results. Book a call with us to explore how we can help you take the next step."
    },
    {
      range: [0, 60],
      label: "A Starting Point",
      description: "Your business may be early in its data-driven journey or facing challenges due to competing priorities. Success depends on a commitment to transparency and informed decision-making. Book a call with us to explore what's held you back and whether this approach aligns with your goals. Let's see if we're the right fit to help."
    }
  ]
}; 